export default __webpack_public_path__ + "static/media/dec2023-3.00422c98.jpg";